export const THANHVIEN_SET_LIST_DATA = 'THANHVIEN_SET_LIST_DATA';
export const THANHVIEN_SET_LIST_META = 'THANHVIEN_SET_LIST_META';
export const THANHVIEN_SET_LIST_DATA_CON = 'THANHVIEN_SET_LIST_DATA_CON';
export const THANHVIEN_SET_LIST_META_CON = 'THANHVIEN_SET_LIST_META_CON';
export const THANHVIEN_SET_LIST_DATA_VO = 'THANHVIEN_SET_LIST_DATA_VO';
export const THANHVIEN_SET_LIST_META_VO = 'THANHVIEN_SET_LIST_META_VO';
export const THANHVIEN_TITLE = 'Thành viên';